export default "/night.54c494b9-441d44.svg";